<div class="max-w-1xl mx-auto bg-white p-8 rounded-lg shadow-lg">
  <div class="flex flex-wrap pb-4 justify-start">
    <h1 class="headeradminui-text pl-2">Email Templates logs</h1>
  </div>
  <div class="flex flex-row justify-end mb-3">
    <div class="w-[40%]">
      <nz-input-group nzSearch nzSize="large" [nzAddOnAfter]="suffixButton">
        <input
          type="text"
          nz-input
          [(ngModel)]="globalSearchInput"
          placeholder="Search for email"
        />
      </nz-input-group>
    </div>
  </div>

  <ng-template #suffixButton>
    <button
      nz-button
      nzType="primary"
      nzSize="small"
      nzSearch
      (click)="searchGlobal()"
    >
      Search
    </button>
  </ng-template>
  <ng-template #tableHead>
    <div nz-row nzJustify="space-between">
      <div nz-col>
        <span class="font-bold">Email templates Logs</span>
      </div>
      <div class="flex gap-2">
        <!-- <nz-switch
          [(ngModel)]="showTestCount"
          (ngModelChange)="showTestUsers()"
          nzCheckedChildren="hide test challenges"
          nzUnCheckedChildren="show test challenges"
        ></nz-switch> -->
        <div nz-col>
          <button
            class="btn-color"
            nz-button
            nzSize="small"
            nzType="primary"
            (click)="resetFilter()"
          >
            Clear filter
          </button>
        </div>
      </div>
    </div>
  </ng-template>
  <nz-spin
    [nzSpinning]="pageLoading"
    nzTip="Fetching Email Template Logs......"
  >
    <nz-table
      #Table
      [nzTitle]="tableHead"
      [nzScroll]="{ y: '500px' }"
      class="mt-5"
      [nzData]="data"
      [nzShowPagination]="true"
      nzFrontPagination="false"
      [nzTotal]="totalCount"
      [nzPageSize]="pageSize"
      [nzBordered]="true"
      [nzShowSizeChanger]="true"
      [nzPageSizeOptions]="pageSizeOptions"
      [nzPageIndex]="pageNo"
      nzTableLayout="fixed"
      (nzPageIndexChange)="nzPageIndexChange($event)"
      (nzPageSizeChange)="nzPageSizeChange($event)"
    >
      <thead>
        <tr>
          <th>Partner</th>
          <th>HR(email)</th>
          <th>Date</th>
          <th (nzSortOrderChange)="totalSendSort($event)" nzShowSort="true">
            Employees
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of Table.data">
          <td>
            {{ data.partnerName }}
          </td>
          <td>
            {{ data.sendBy }}
          </td>
          <td>
            {{ utils.convertEpochToFormattedDate(data.date) }}
          </td>

          <td>
            {{ data.noOfEmployees }}
          </td>
        </tr>
      </tbody>
    </nz-table>
  </nz-spin>
</div>
